// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OptionInput__label {
  height: 8.57rem;
  min-width: 7.85rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: solid 2px var(--unknown-grey-to-review-C0C0C0);
  padding: 0 1.42rem;
  cursor: pointer;
}

.OptionInput__label-text {
  color: var(--palette-gray-8);
  font-weight: 500;
  font-size: 0.86rem;
  margin-top: 0.71rem;
}

.OptionInput__input:checked ~ .OptionInput__label .OptionInput__label-text {
  color: var(--palette-trovit-blue);
}

.OptionInput .OptionInput__label svg path {
  fill: var(--unknown-grey-to-review-C0C0C0);
}

.OptionInput .OptionInput__input {
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
}

.OptionInput .OptionInput__input:checked ~ .OptionInput__label {
  border: 2px solid var(--palette-trovit-blue);
}

.OptionInput .OptionInput__input:checked ~ .OptionInput__label svg path {
  fill: inherit;
}
`, "",{"version":3,"sources":["webpack://./js/components/library/html/input/OptionInput/OptionInput.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sDAAsD;EACtD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf","sourcesContent":[".OptionInput__label {\n  height: 8.57rem;\n  min-width: 7.85rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  border: solid 2px var(--unknown-grey-to-review-C0C0C0);\n  padding: 0 1.42rem;\n  cursor: pointer;\n}\n\n.OptionInput__label-text {\n  color: var(--palette-gray-8);\n  font-weight: 500;\n  font-size: 0.86rem;\n  margin-top: 0.71rem;\n}\n\n.OptionInput__input:checked ~ .OptionInput__label .OptionInput__label-text {\n  color: var(--palette-trovit-blue);\n}\n\n.OptionInput .OptionInput__label svg path {\n  fill: var(--unknown-grey-to-review-C0C0C0);\n}\n\n.OptionInput .OptionInput__input {\n  position: absolute;\n  opacity: 0;\n  height: 0;\n  width: 0;\n}\n\n.OptionInput .OptionInput__input:checked ~ .OptionInput__label {\n  border: 2px solid var(--palette-trovit-blue);\n}\n\n.OptionInput .OptionInput__input:checked ~ .OptionInput__label svg path {\n  fill: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
